export default {
  COUPONS_FETCHED: 'COUPONS_FETCHED',
  COUPON_LOAD: 'COUPON_LOAD',
  COUPON_TEMPLATES_FETCHED: 'COUPON_TEMPLATES_FETCHED',
  COUPON_TEMPLATES_LOAD: 'COUPON_TEMPLATES_LOAD',
  COUPON_DETAIL: 'COUPON_DETAIL',
  COUPON_BUTTON_LOAD: 'COUPON_BUTTON_LOAD',
};
